import type { IGenericBaseModel } from "models/shared/GenericBaseModel";
import { ContainerMeasureModel } from "models/locker/entities/ContainerMeasureModel";
import { ContainerTypeModel } from "models/locker/entities/ContainerTypeModel";
import { SerialPortModel } from "./SerialPortModel";

export interface IContainerModel extends IGenericBaseModel {
  uuid: string;
  name: string;
  serialName: string;
  isAvailable: boolean
  isActive: boolean
  failed: boolean
  ordering: number
  containerMeasure: ContainerMeasureModel
  containerType: ContainerTypeModel
  serialPort?: SerialPortModel;
}

export class ContainerModel implements IContainerModel {
  uuid: string;
  key: React.Key;
  name: string;
  serialName: string;
  isAvailable: boolean;
  isActive: boolean;
  failed: boolean
  ordering: number
  containerMeasure: ContainerMeasureModel
  containerType: ContainerTypeModel
  serialPort?: SerialPortModel;

  constructor(data: IContainerModel) {
    this.uuid = data.uuid;
    this.key = data.uuid;
    this.name = data.name;
    this.serialName = data.serialName;
    this.serialPort = data?.serialPort;
    this.isAvailable = data.isAvailable;
    this.isActive = data.isActive;
    this.failed = data.failed;
    this.ordering = data.ordering;
    this.containerMeasure = new ContainerMeasureModel(data.containerMeasure);
    this.containerType = new ContainerTypeModel(data.containerType);
    this.serialPort = data.serialPort ? new SerialPortModel(data.serialPort) : undefined;
  }
}